"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFonts = exports.Fonts = void 0;
const styled_components_1 = require("styled-components");
const OpenSansBold = require('./assets/fonts/OpenSans/OpenSans-Bold.ttf');
const OpenSansSemiBold = require('./assets/fonts/OpenSans/OpenSans-SemiBold.ttf');
const OpenSansRegular = require('./assets/fonts/OpenSans/OpenSans-Regular.ttf');
const MontserratBold = require('./assets/fonts/Montserrat/Montserrat-Bold.ttf');
const MontserratRegular = require('./assets/fonts/Montserrat/Montserrat-Regular.ttf');
const KomikaTitle = require('./assets/fonts/KomikaTitle/KomikaTitle.ttf');
exports.Fonts = (0, styled_components_1.createGlobalStyle) `
@font-face {
    font-family: 'MontserratBold';
    src: url(${MontserratBold}) format('truetype');
}

@font-face {
  font-family: 'MontserratRegular';
  src: url(${MontserratRegular}) format('truetype');
}

@font-face {
    font-family: 'OpenSansRegular';
    src: url(${OpenSansRegular}) format('truetype');
}

@font-face {
  font-family: 'OpenSansSemiBold';
  src: url(${OpenSansSemiBold}) format('truetype');
}


@font-face {
  font-family: 'OpenSansBold';
  src: url(${OpenSansBold}) format('truetype');
}

@font-face {
    font-family: 'KomikaTitle';
    src: url(${KomikaTitle}) format('truetype');
}
`;
const initFonts = (onFinish) => {
    console.log("[WARNING] This function (initFonts) should only be used in native components.");
};
exports.initFonts = initFonts;
//# sourceMappingURL=fonts.js.map